import { render, staticRenderFns } from "./TaxReturnReservesAdditionSection.vue?vue&type=template&id=1c86c1c6&scoped=true&"
import script from "./TaxReturnReservesAdditionSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnReservesAdditionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c86c1c6",
  null
  
)

export default component.exports